import type Vue from 'vue';
import { resolveInjected } from '~/utils/nuxt-instance';

/** The root Nuxt instance, used as a global event bus ($nuxt.$emit/$on). */
export function useNuxtEventBus(): Vue['$nuxt'] {
  return resolveInjected('$nuxt');
}
